import React from "react";
import { motion } from "framer-motion"; // Animations ke liye
import { servicesData, heroData } from "../data/mock";
import {
  MapPin,
  Plane,
  Car,
  Route,
  Users,
  MessageCircle,
  ChevronRight,
} from "lucide-react";
import { Card } from "./ui/card";

const iconMap = { MapPin, Plane, Car, Route, Users };

const ServicesSection = () => {
  const handleServiceEnquiry = (serviceTitle) => {
    const message = encodeURIComponent(
      `Hello Bahubali Cabs! I'm interested in your *${serviceTitle}* service. Please share pricing.`,
    );
    window.open(`https://wa.me/${heroData.whatsapp}?text=${message}`, "_blank");
  };

  return (
    <section
      id="services"
      className="py-24 bg-slate-50 relative overflow-hidden"
    >
      {/* 🔹 Luxury Background Decor */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-amber-100/40 rounded-full blur-[120px] translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-amber-200/20 rounded-full blur-[120px] -translate-x-1/2 translate-y-1/2" />

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-amber-600 font-black uppercase tracking-[0.3em] text-xs mb-4 block"
          >
            Premium Travel Solutions
          </motion.span>
          <h2 className="text-4xl md:text-6xl font-black text-slate-900 tracking-tighter mb-6">
            Udaipur <span className="text-amber-500 italic">Cab</span> Service
          </h2>
          <div className="w-20 h-1.5 bg-amber-500 mx-auto rounded-full mb-8" />
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Car;

            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="group relative h-[450px] overflow-hidden rounded-[2.5rem] border-none shadow-2xl shadow-slate-200/50 flex flex-col transition-all duration-500 hover:-translate-y-2">
                  {/* BACKGROUND IMAGE WITH PREMIUM OVERLAY */}
                  <div className="absolute inset-0">
                    <img
                      src={
                        service.backgroundImage ||
                        "/images/fallback-service.jpg"
                      }
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    {/* 🔹 Fixed Readability Overlay */}
                    <div className="absolute inset-0 bg-white/90 group-hover:bg-amber-600/90 transition-all duration-500" />
                  </div>

                  {/* CONTENT */}
                  <div className="relative p-10 flex flex-col h-full z-20">
                    <div className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center mb-8 shadow-xl group-hover:bg-white transition-all duration-500">
                      <IconComponent className="w-8 h-8 text-white group-hover:text-amber-600" />
                    </div>

                    <h3 className="text-2xl font-black text-slate-900 mb-4 group-hover:text-white transition-colors uppercase italic tracking-tight">
                      {service.title}
                    </h3>

                    <p className="text-slate-600 font-medium leading-relaxed group-hover:text-white/90 transition-colors">
                      {service.description}
                    </p>

                    {/* WhatsApp CTA - Always visible on mobile, hover on desktop */}
                    <div className="mt-auto">
                      <button
                        onClick={() => handleServiceEnquiry(service.title)}
                        className="flex items-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-xl font-bold text-sm group-hover:bg-white group-hover:text-amber-600 transition-all shadow-lg"
                      >
                        <MessageCircle className="w-4 h-4" />
                        Book Now
                        <ChevronRight className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
